/**
 * Утилиты для работы с именами администраторов
 */

/**
 * Очищает имя администратора от суффикса языка
 * @param name - имя администратора (например, "Администратор RU" или "Администратор IT")
 * @returns очищенное имя (например, "Администратор")
 */
export const cleanAdminName = (name: string): string => {
    return name.replace(/\s+(RU|IT)$/, '');
};

/**
 * Создает отображаемое имя администратора с короной
 * @param name - имя администратора
 * @returns имя с короной (например, "👑 Администратор")
 */
export const getAdminDisplayName = (name: string): string => {
    return `👑 ${cleanAdminName(name)}`;
};
